var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCardDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.00049C17.9706 5.00049 22 8.35835 22 12.5005C22 14.5591 21.0047 16.424 19.3933 17.7792C19.1517 17.9824 19 18.2767 19 18.5924V21.0005H17L16.2062 19.8679C16.083 19.6921 15.8616 19.6157 15.6537 19.6692C13.9248 20.1137 12.0752 20.1137 10.3463 19.6692C10.1384 19.6157 9.91703 19.6921 9.79384 19.8679L9 21.0005H7V18.6159C7 18.2871 6.83835 17.9793 6.56764 17.7926C5.49285 17.0516 2 15.6019 2 14.0587V12.5005C2 11.9088 2.44771 11.4291 3 11.4291C3.60665 11.4291 4.10188 11.1934 4.30205 10.5666C5.32552 7.3617 8.83187 5.00049 13 5.00049Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.00024C13.868 7.67526 13.1963 7.50024 12.5 7.50024C11.8037 7.50024 11.132 7.67526 10.5 8.00024",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49981 11.0005H7.50879",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.5C21.5 8 22 7.06296 22 5.83053C22 4.26727 20.6569 3 19 3C18.6494 3 18.3128 3.05676 18 3.16106",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardDark);
export default __webpack_public_path__ + "static/media/gift-card-dark.a95bb0931317dfde9a4af4d17958a7c8.svg";
export { ForwardRef as ReactComponent };